import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          精选专题
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          编辑精心策划的主题影单，发现更多好片
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={item.title}
              className={`group relative overflow-hidden rounded-xl cursor-pointer ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative ${idx === 0 ? 'aspect-[21/9] lg:aspect-[21/7]' : 'aspect-[16/9]'} overflow-hidden rounded-xl`}>
                <img
                  src={item.image}
                  alt={`${item.title} - 80s电影网精选专题`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-foreground-50 text-xs font-medium mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-1 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-300">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}